export const GET_CATEGORIES = 'getCategories';
export const GET_FILTEROPTIONS = 'getFilterOptions';
export const SEARCH = 'search';